import React, { useState } from 'react';
import { FaGlobe, FaMailBulk, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';
import RequestQuote from "./RequestQuote";

const ContactInfo = ({ company }) => {
    const [companyData] = useState(company);

    const getAddress = () => {
        if (companyData?.address) {
            return companyData.address.substring(0, 5) + '*'.repeat(Math.max(companyData.address.length - 50, 0));
        }
        return '';
    };

    const getContact = () => {
        if (companyData?.contact) {
            return companyData.contact.substring(0, 2) + '*'.repeat(Math.max(companyData.contact.length - 4, 0)) + companyData.contact.substring(companyData.contact.length - 2);
        }
        return '';
    };

    const getEmail = () => {
        if (companyData?.mail_address) {
            return companyData.mail_address.substring(0, 2) + '*'.repeat(Math.max(companyData.mail_address.length - 4, 0)) + companyData.mail_address.substring(companyData.mail_address.length - 4);
        }
        return '';
    };

    const getWebsite = () => {
        if (companyData?.website) {
            return companyData.website.substring(0, 4) + '*'.repeat(Math.max(companyData.website.length - 4, 0)) + companyData.website.substring(companyData.website.length - 4);
        }
        return '';
    };

    return (
        <>
            <div className="container">
                <div id="aon-provider-coInfo" className="sf-provi-coInfo-box margin-b-50 sf-provi-fullBox">
                    <h3 className="sf-provi-title s-22 fw-800 text-drk-primary">Contact Verification</h3>
                    <div className="sf-divider-line mb-0" />
                    <div className="row">
                        <div className="col-md-12">
                            <div className="row d-flex flex-wrap a-b-none">
                                <div className="col-md-3">
                                    <div className="sf-provi-coInfo-box">
                                        <h5 className='fw-800 s-16 text-drk-primary'>Address</h5>
                                        <div className={`sf-provi-coInfo-text text-white text-center ${companyData?.office_location ? "bg-success" : "bg-danger"}`}>
                                            <FaMapMarkerAlt className="mr-2" />
                                            {companyData?.office_location ? "Verified" : "Unverifired"}
                                        </div>
                                        <div className="sf-provi-coInfo-text">
                                            {getAddress()}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="sf-provi-coInfo-box">
                                        <h5 className='fw-800 s-16 text-drk-primary'>Contact</h5>
                                        <div className={`sf-provi-coInfo-text text-white text-center ${companyData?.contact ? "bg-success" : "bg-danger"}`}>
                                            <FaPhoneAlt className="mr-2" />
                                            {companyData?.contact ? "Verified" : "Unverifired"}
                                        </div>
                                        <div className="sf-provi-coInfo-text">
                                            {getContact()}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="sf-provi-coInfo-box">
                                        <h5 className='fw-800 s-16 text-drk-primary'>Email</h5>
                                        <div className={`sf-provi-coInfo-text text-white text-center ${companyData?.mail_address ? "bg-success" : "bg-danger"}`}>
                                            <FaMailBulk className="mr-2" />
                                            {companyData?.mail_address ? "Verified" : "Unverifired"}
                                        </div>
                                        <div className="sf-provi-coInfo-text">
                                            {getEmail()}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="sf-provi-coInfo-box">
                                        <h5 className='fw-800 s-16 text-drk-primary'>Web</h5>
                                        <div className={`sf-provi-coInfo-text text-white text-center ${companyData?.website ? "bg-success" : "bg-danger"}`}>
                                            <FaGlobe className="mr-2" />
                                            {companyData?.website ? "Verified" : "Unverifired"}
                                        </div>
                                        <div className="sf-provi-coInfo-text">
                                            {getWebsite()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="sf-divider-line mt-5 " />
                            <div className="row">
                                <div className="col-md-4 sf-provi-coInfo-hour sf-list-business-hours ">
                                    <ul className="list-unstyled sf-bh-wrapper pl-2">
                                        <h3 className="sf-provi-title fw-800 text-drk-primary s-22">Reply Timings</h3>
                                        <div className="sf-divider-line" />
                                        <div className='timing-box radius-sm shadow-lg  p-3'>
                                            <li className='time-box'>
                                                <span>
                                                    Monday<b>:</b>
                                                </span>
                                                <span>09:00 am to 06:00 pm</span>
                                            </li>
                                            <li className='time-box'>
                                                <span>
                                                    Tuesday<b>:</b>
                                                </span>
                                                <span>09:00 am to 06:00 pm</span>
                                            </li>
                                            <li className='time-box'>
                                                <span>
                                                    Wednesday<b>:</b>
                                                </span>
                                                <span>09:00 am to 06:00 pm</span>
                                            </li>
                                            <li className='time-box'>
                                                <span>
                                                    Thursday<b>:</b>
                                                </span>
                                                <span>09:00 am to 06:00 pm</span>
                                            </li>
                                            <li className='time-box'>
                                                <span>
                                                    Friday<b>:</b>
                                                </span>
                                                <span>09:00 am to 06:00 pm</span>
                                            </li>
                                            <li className='time-box'>
                                                <span>
                                                    Saturday<b>:</b>
                                                </span>
                                                <span>Closed</span>
                                            </li>
                                            <li className='time-box'>
                                                <span>
                                                    Sunday<b>:</b>
                                                </span>
                                                <span>Closed</span>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                                <RequestQuote />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactInfo;
